<template>
    <section :id="`element-${settings.id}`" class="elle-locations" :style="{ backgroundColor: settings?.color }">
        <LoopsLocations :locations="locations" />
    </section>
</template>

<script setup lang="ts">
const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});

const locations = computed(() => props.settings.locations);
</script>
